import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatIconModule, MatButtonModule, MatExpansionModule } from '@angular/material';
import { CalendarSchedulesComponent } from './calendar-schedules.component';
import { CalendarSchedulesModalComponent } from './calendar-schedules-modal/calendar-schedules-modal.component';

@NgModule({
  declarations: [
    CalendarSchedulesComponent,
    CalendarSchedulesModalComponent
  ],
  exports: [
    CalendarSchedulesComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule
  ],
  entryComponents: [
    CalendarSchedulesModalComponent
  ]
})
export class CalendarSchedulesModule { }

